<template>
  <div
    :class="[
      'SPASelect-container',
      iconStyle,
      isPositionRelative ? 'relative' : '',
    ]"
  >
    <MDBSelect v-bind="$attrs" id="input-select" ref="selectRef" />
    <span class="icon">
      <CaretDownIcon />
    </span>
  </div>
</template>

<script setup lang="ts">
import { MDBSelect } from 'mdb-vue-ui-kit';
import { ref, onMounted } from 'vue';
import CaretDownIcon from '~icons/ph/caret-down';

defineProps({
  iconStyle: {
    type: String,
    default: 'default',
    validator: (value) => {
      return ['caret-down', 'default'].includes(value);
    },
  },
  isPositionRelative: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['selectRef']);
const selectRef = ref(null);

onMounted(() => {
  emit('selectRef', selectRef.value);
});
</script>

<style lang="scss" scoped>
.SPASelect-container {
  :deep(.select-wrapper) {
    .form-outline {
      position: relative;

      .form-control {
        color: $neutral-200;
        text-overflow: ellipsis;
        overflow: hidden;

        &.focused ~ .select-label {
          color: $green-300;
        }

        & ~ .select-arrow {
          color: $neutral-90;
        }

        & ~ .form-notch div {
          border-color: $neutral-50;
        }

        & ~ .form-label {
          color: $neutral-50;
        }

        &.focused ~ .select-arrow,
        &:focus ~ .form-label {
          color: $green-300;
        }

        &:focus ~ .form-notch .form-notch-leading,
        &.focused ~ .form-notch .form-notch-leading {
          border-top-color: $green-300;
          border-bottom-color: $green-300;
          border-left-color: $green-300;
        }

        &:focus ~ .form-notch .form-notch-middle,
        &.focused ~ .form-notch .form-notch-middle {
          border-color: $green-300;
        }

        &:focus ~ .form-notch .form-notch-trailing,
        &.focused ~ .form-notch .form-notch-trailing {
          border-top-color: $green-300;
          border-bottom-color: $green-300;
          border-right-color: $green-300;
        }
      }
    }
  }

  :deep(.select-dropdown-container) {
    .select-input.focused ~ .select-arrow {
      color: $green-300;
    }
    .select-option {
      color: $neutral-200;
      .select-option-text {
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
    .select-option.active,
    .select-option.selected.active {
      background-color: $green-50 !important;
    }
    .select-option:hover:not(.disabled) {
      background-color: $neutral-10;
    }
  }

  .icon {
    display: none;
  }
}

.caret-down {
  .icon {
    position: absolute;
    right: 1.5%;
    top: 7%;
    color: $neutral-90;
    display: block;
  }

  :deep(.select-wrapper) {
    .form-outline {
      .form-control {
        & ~ .select-arrow {
          display: none;
        }
      }
    }
  }
}

.relative {
  position: relative;
}
</style>
